import React from 'react';
import EmailCheck from './../EmailCheck.react';
import {FormattedMessage, defineMessages, IntlShape} from 'react-intl';
import StatusIcon from './../StatusIcon.react';
import {sendError} from '../../../app/errorDisplayer';

const messagesResult = defineMessages({
        Ok:{id: 'scenario.screen.emailCheck.result.Ok', 'defaultMessage': 'Verification passes all checks including Syntax, DNS, MX, Mailbox, Deep Server Configuration, Grey Listing.'},
        Bad:{id: 'scenario.screen.emailCheck.result.Bad', 'defaultMessage': 'Verification fails checks for definitive reasons.'},
        RetryLater: {id: 'scenario.screen.emailCheck.result.RetryLater', 'defaultMessage': 'Conclusive verification result cannot be achieved at this time.'},
        Unverifiable: {id: 'scenario.screen.emailCheck.result.Unverifiable', 'defaultMessage': 'Conclusive verification result cannot be achieved.'},
		Unknown: {id: 'scenario.screen.emailCheck.result.Unknown', 'defaultMessage': 'The email address status is unknow.'},
});
const messagesReason = defineMessages({
    AtSignNotFound: {id: 'scenario.screen.emailCheck.reason.AtSignNotFound', 'defaultMessage': 'The required ‘@’ sign is not found in email address.'},
    DomainIsInexistent:{id: 'scenario.screen.emailCheck.reason.DomainIsInexistent', 'defaultMessage': 'The domain defined in the email address does not exist.'},
    DomainIsWellKnownDea:{id: 'scenario.screen.emailCheck.reason.DomainIsWellKnownDea', 'defaultMessage': 'The domain is a well known Disposable Email Address.'},
    GreyListing:{id: 'scenario.screen.emailCheck.reason.GreyListing', 'defaultMessage': 'Grey Listing is in operation. It is not possible to validate email boxes in real-time where grey listing is in operation.'},
    MailboxFull: {id: 'scenario.screen.emailCheck.reason.MailboxFull', 'defaultMessage': 'The mailbox is full.'},
    MailboxDoesNotExist:{id: 'scenario.screen.emailCheck.reason.MailboxDoesNotExist', 'defaultMessage': 'The mailbox does not exist.'},
    NoMxServersFound: {id: 'scenario.screen.emailCheck.reason.NoMxServersFound', 'defaultMessage': 'There are no mail servers defined for this domain.'},
    ServerDoesNotSupportInternationalMailboxes: {id: 'scenario.screen.emailCheck.reason.ServerDoesNotSupportInternationalMailboxes', 'defaultMessage': 'The server does not support international mailboxes.'},
    ServerIsCatchAll: {id: 'scenario.screen.emailCheck.reason.ServerIsCatchAll', 'defaultMessage': 'The server is configured for catch all and responds to all email verifications with a status of Ok.'},
    Success: {id: 'scenario.screen.emailCheck.reason.Success', 'defaultMessage': 'Successful verification.'},
    TooManyAtSignsFound: {id: 'scenario.screen.emailCheck.reason.TooManyAtSignsFound', 'defaultMessage': 'Too many ‘@’ signs found in email address.'},
    Unknown: {id: 'scenario.screen.emailCheck.reason.Unknown', 'defaultMessage': 'The reason for the verification result is unknown.'},
    TransientNetworkFault: {id: 'scenario.screen.emailCheck.reason.TransientNetworkFault', 'defaultMessage': 'A temporary network fault occurred during verification.'},
    PossibleSpamTrapDetected: {id: 'scenario.screen.emailCheck.reason.PossibleSpamTrapDetected', 'defaultMessage': 'A possible spam trap email address or domain has been detected.'}
});
const messagesReasonShort = defineMessages({
    AtSignNotFound: {id: 'scenario.screen.emailCheck.reason.short.AtSignNotFound', 'defaultMessage': '‘@’ not found'},
    DomainIsInexistent:{id: 'scenario.screen.emailCheck.reason.short.DomainIsInexistent', 'defaultMessage': 'Domain does not exist'},
    DomainIsWellKnownDea:{id: 'scenario.screen.emailCheck.reason.short.DomainIsWellKnownDea', 'defaultMessage': 'The domain is DEA'},
    GreyListing:{id: 'scenario.screen.emailCheck.reason.short.GreyListing', 'defaultMessage': 'Grey Listing'},
    MailboxFull: {id: 'scenario.screen.emailCheck.reason.short.MailboxFull', 'defaultMessage': 'Mailbox full.'},
    MailboxDoesNotExist:{id: 'scenario.screen.emailCheck.reason.short.MailboxDoesNotExist', 'defaultMessage': 'Mailbox does not exist.'},
    NoMxServersFound: {id: 'scenario.screen.emailCheck.reason.short.NoMxServersFound', 'defaultMessage': 'No mail servers'},
    ServerDoesNotSupportInternationalMailboxes: {id: 'scenario.screen.emailCheck.reason.short.ServerDoesNotSupportInternationalMailboxes', 'defaultMessage': 'Server does not support international mailboxes.'},
    ServerIsCatchAll: {id: 'scenario.screen.emailCheck.reason.short.ServerIsCatchAll', 'defaultMessage': 'Server is catch all'},
    Success: {id: 'scenario.screen.emailCheck.reason.short.Success', 'defaultMessage': 'Successful verification.'},
    TooManyAtSignsFound: {id: 'scenario.screen.emailCheck.reason.short.TooManyAtSignsFound', 'defaultMessage': 'Too many ‘@’ found'},
    Unknown: {id: 'scenario.screen.emailCheck.reason.short.Unknown', 'defaultMessage': 'Unknown reason'},
    TransientNetworkFault: {id: 'scenario.screen.emailCheck.reason.short.TransientNetworkFault', 'defaultMessage': 'Transient network fault'},
    PossibleSpamTrapDetected: {id: 'scenario.screen.emailCheck.reason.short.PossibleSpamTrapDetected', 'defaultMessage': 'Possible spam trap detected'}
});

export default class EmailCheckHippo extends EmailCheck {
	static handlerName = "email-check-hippo";

	getIcon() {
        return 'emailhippo';
    }

	getPreviewData() {
        return [
            {
                "com.dativery.model.entities.countries@countryCodeIso31661Alpha2": "US",
                "com.dativery.model.entities.emailAddress@domainPart": "example.org",
                "com.dativery.model.entities.emailAddress@emailAddress": "valid@example.org",
                "com.dativery.model.entities.emailAddress@localPart": "valid",
                "com.dativery.model.entities.emailAddress@role": true,
                "com.emailhippo.emailAddress@reason": "Success",
                "com.emailhippo.emailAddress@result": "Ok",
            }, {
                "com.dativery.model.entities.countries@countryCodeIso31661Alpha2": "RU",
                "com.dativery.model.entities.emailAddress@domainPart":"example.com",
                "com.dativery.model.entities.emailAddress@emailAddress":"invalid@example.com",
                "com.dativery.model.entities.emailAddress@localPart":"invalid",
                "com.emailhippo.emailAddress@reason":"NoMxServersFound",
                "com.emailhippo.emailAddress@result":"Bad",
            }, {
                "com.dativery.model.entities.emailAddress@domainPart":"example.com",
                "com.dativery.model.entities.emailAddress@emailAddress":"greylisted@example.com",
                "com.dativery.model.entities.emailAddress@localPart":"greylisted",
                "com.emailhippo.emailAddress@reason":"GreyListing",
                "com.emailhippo.emailAddress@result":"Unverifiable",
            },
        ];
    }

	isEmailOk(emailValue) {
		return !Boolean(emailValue["com.emailhippo.emailAddress@result"]) || emailValue["com.emailhippo.emailAddress@result"] === 'Ok';
	}

	getMessageReason(reason) {
        if (reason in messagesReason) {
            return this.props.intl.formatMessage(messagesReason[reason]);
        }
        return undefined;
    }

    getMessageReasonShort(reason) {
        if (reason in messagesReasonShort) {
            return this.props.intl.formatMessage(messagesReasonShort[reason]);
        }
        return null;
    }

    renderEmailRow(emailValue) {
		let icon = '';
		let title = '';

        if (this.isEmailOk(emailValue)) {
			icon = StatusIcon.OK;
			title = this.props.intl.formatMessage(messagesResult["Ok"]);
        }
		else {
			icon = emailValue["com.emailhippo.emailAddress@result"] === 'Bad' ? StatusIcon.ERROR : StatusIcon.HELP;

			if (messagesResult[emailValue["com.emailhippo.emailAddress@result"]]) {
				title = this.props.intl.formatMessage(messagesResult[emailValue["com.emailhippo.emailAddress@result"]]);
			} else {
				sendError(new Error('Unknown Email Hippo result ("com.emailhippo.emailAddress@result")', true));
			}
		}

        return (
			<div>
				<strong>{emailValue["com.dativery.model.entities.emailAddress@emailAddress"]}</strong>
				&nbsp;
				<StatusIcon title={title} type={icon} />
			</div>
		);
    }

	renderServerProblem(emailValue) {
		if (this.isEmailOk(emailValue)) {
			return null;
		}

		let text = this.getMessageReasonShort(emailValue["com.emailhippo.emailAddress@reason"]);

		if (!text) {
			return null;
		}

		return (
			<div>
				<FormattedMessage defaultMessage="Problem:" id="scenario.screen.emailCheck.problem" />
				&nbsp;
				<span title={this.getMessageReason(emailValue["com.emailhippo.emailAddress@reason"])}>{text}</span>
			</div>
		);
	}

	renderServerLocation(emailValue) {
		if (emailValue["com.dativery.model.entities.countries@countryCodeIso31661Alpha2"]) {
			return (
				<div><FormattedMessage defaultMessage="Mail server country:" id="scenario.screen.emailCheck.mailServerCountry" /> {emailValue["com.dativery.model.entities.countries@countryCodeIso31661Alpha2"]}</div>
			);
		}
		return null;
	}

	renderEmail(emailValue, idx) {
        return (
			<div key={idx}>
				{this.renderEmailRow(emailValue)}
				{this.renderServerProblem(emailValue)}
				{this.renderServerLocation(emailValue)}
			</div>
		);
	}
}
